import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export interface DownloadRepresentationPdfResult {
  url: string;
  content: any;
}

export interface DownloadRepresentationPdfQueryParams {
  user_id: number;
  company_id: number;
}

export class DownloadRepresentationPdfQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher
  ) { }

  async run(params: DownloadRepresentationPdfQueryParams): Promise<DownloadRepresentationPdfResult> {
    const args = {
      user_id: params.user_id,
      company_id: params.company_id
    }

    const res = await this.dispatcher.dispatch('download.representation.pdf', args);
    return res as DownloadRepresentationPdfResult;
  }
}
